import { useState } from 'react';
import { ITutorList } from 'types/Tutor';

import { Grid } from '@mui/material';

import { DashboardTitle } from '../../../components/Titles';
import { SearchBar } from './SearchBar';
import { TutorList } from './TutorList';

export const Tutor: React.FC = () => {
  const [tutors, setTutors] = useState<ITutorList>({
    count: 0,
    list: [],
    totalPages: 1,
  });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE TUTORES" />
      </Grid>
      <Grid item xs={12}>
        <SearchBar
          setLoading={setLoading}
          setTutors={setTutors}
          currentPage={page}
          setMaxPage={setMaxPage}
        />
      </Grid>

      <Grid item xs={12}>
        <TutorList
          loading={loading}
          {...tutors}
          currentPage={page}
          setPage={setPage}
          maxPage={maxPage}
        />
      </Grid>
    </Grid>
  );
};

